import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SenderTypeConditionProps {
  value: "internal" | "external";
  onChange: (value: "internal" | "external") => void;
}

export function SenderTypeCondition({ value, onChange }: SenderTypeConditionProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Select sender type" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="internal">Sender is internal</SelectItem>
        <SelectItem value="external">Sender is external</SelectItem>
      </SelectContent>
    </Select>
  );
}
